import { css, CSSResultGroup, html, TemplateResult } from "lit";
import { BaseElement } from "../../core/ui-kit/BaseElement";
import { customElement } from "lit/decorators.js";

const styles = css`
  /* Pop-up Stilleri */
  .cm-popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 20000;
    animation: fadeIn 0.3s ease-in-out;
  }

  .cm-popup-content {
    background: white;
    border-radius: 16px;
    padding: 32px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    max-width: 500px;
    width: 90%;
    animation: popupSlideIn 0.3s ease-out;
  }

  .cm-popup-header {
    text-align: center;
    margin-bottom: 24px;
  }

  .cm-popup-title {
    font-size: 24px;
    font-weight: 700;
    color: #333;
    margin: 0 0 8px 0;
  }

  .cm-popup-subtitle {
    font-size: 16px;
    color: #666;
    margin: 0;
  }

  .cm-popup-actions {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
  }

  .cm-popup-btn {
    padding: 12px 24px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    border: none;
    min-width: 100px;
  }

  .cm-popup-btn.cancel {
    background: #f8f9fa;
    color: #666;
    border: 1px solid #e1e5e9;
  }

  .cm-popup-btn.cancel:hover {
    background: #e9ecef;
  }

  .cm-popup-btn.create {
    background: #325a82;
    color: white;
  }

  .cm-popup-btn.create:hover {
    background: #2a4d70;
  }

  .cm-popup-btn.create:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

@customElement("configurator-modal2")
export class ConfiguratorModal extends BaseElement {
  static styles?: CSSResultGroup | undefined = styles;
  protected useShadowRoot: boolean = true;
  private _quit() {
    this.remove();
  }

  protected renderHtml(): TemplateResult {
    return html` <div class="cm-popup-overlay" @click=${this._quit}>
      <div class="cm-popup-content">
        <div class="cm-popup-header">
          <h2 class="cm-popup-title">${this.title}</h2>
          <div class="cm-popup-content"><slot></slot></div>
        </div>
      </div>
    </div>`;
  }
}
